import { Button as ButtonN, CircularProgress } from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { Component } from "react";
import { TooltipCustom, color4 } from "../infra/styleGlobal";
import { NavLink } from "react-router-dom";
import { View } from ".";
import {  useTheme } from "@mui/material";

const styles =  (theme) => {
  return {
    btn: {
      alignSelf: "center",
      height: 40,
      margin: 5,
      boxShadow: 'none',
      maxWidth: 200,
      minWidth: 150,
      borderRadius: 5,
      width: "100%",
      backgroundColor: "#59B200",
      '&:hover': {
        backgroundColor: 'rgba(200,200,200,0.3)',
        boxShadow: 'none',
      }
    },
}}
class ButtonClass extends Component {

  render() {
    let { tooltip } = this.props;
    if (tooltip) {
      return (
        <TooltipCustom
          title={tooltip}  >
          {this.navlink()}
        </TooltipCustom>
      )
    } else {
      return this.navlink();
    }
  }

  navlink() {
    let { to, stylevav } = this.props;
    if (to) {
      return (
        <NavLink
          to={to}
          activeClassName="active"
          style={{
            '&:hover': {
              backgroundColor: 'none',
              boxShadow: 'none',
            },
            maxWidth: 260, width: "100%", alignSelf: 'center', alignItems: 'center', justifyContent: 'center', ...stylevav
          }}
        >
          {this.renderBody()}
        </NavLink>
      )
    } else {
      return (
        this.renderBody()
      )
    }
  }



  renderBody() {
    let props = this.props;
    let { theme, secondary, onClick, onPress, classes, icon, load, style = {}, ...other } = props;

    let styletext = props.styletext ? props.styletext : {};
    let newStyle = { ...style }
    if (secondary) {
      newStyle.backgroundColor = color4
    }
    return (
      <ButtonN
        sx={styles(theme).btn}
        style={newStyle}
        variant="contained"
        color="secondary"
        disabled={props.load}
        elevation={0}
        onClick={event => {
          if (onClick) onClick(event);
          if (onPress) onPress(event);
        }}
        {...other}
      >
        {props.icon != null ?
          <View style={{ marginRight: 5 }} >
            {props.icon}
          </View> : null
        }

        {props.load &&
          <CircularProgress style={{ color: "#FFFFFF" }} size={24} />
        }
        {!props.load &&
          <Typography
            style={{ ...{ textTransform: "none" }, ...styletext }}
          >
            {props.text}
          </Typography>
        }

        {props.iconRight != null ?
          <View style={{ marginRight: 5 }} >
            {props.iconRight}
          </View> : null
        }
      </ButtonN>
    );
  }
}

const Button = (props) => {
  const theme = useTheme();
  return (
    <ButtonClass
    theme={theme}
      {...props}
    >
    </ButtonClass>
  );
}



export default  Button;

